import React, { useEffect, useState } from 'react';
import '../../../assets/css/pages/wizard/wizard-6.css';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import classNames from 'classnames';
import s from './OnboardingPage.module.scss';
import { useHistory, Link } from "react-router-dom";
import { createPortal } from 'react-dom';
import {
    sendOtp,
    onboardingRegister,
    sendSnsRegister,
    login,
    getShopifyInfo
} from '../_redux/authCrud';
import { actions } from '../_redux/authRedux';
import { openWebSocket } from '../websocket';
import { WidgetOnly } from '../components/Onboarding/WidgetOnly'
import FakePost from '../components/Onboarding/FakePost'
import { useDispatch } from 'react-redux';
import FirstStepsCustomization from '../components/Onboarding/FirstStepsCustomization'
import CheckIcon from '@material-ui/icons/Check';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import { toAbsoluteUrl } from '../../../../_metronic/_helpers';
import { ReactComponent as Logo } from '../../../assets/onboarding-logo.svg';
import { ReactComponent as LightBulb } from '../../../assets/light-bulb.svg';
import WishlistIcon from '../../../assets/WishlistIconReactiveColor.js';
import fakePostDefaultPicture from '../../../assets/welcome-to-community.png';
import { KTWizard } from '../../../../_metronic/_assets/js/components/wizard';
import { KTImageInput } from '../../../../_metronic/_assets/js/components/image-input';
import { actions as merchantsActions } from '../../../../redux/merchants';
import getStartedPdf from '../../../assets/files/Get Started Guide Squadded.pdf'
import { FirstCustomizationStep } from './OnboardingSteps/FirstCustomizationStep';
import { SecondCustomizationStep } from './OnboardingSteps/SecondCustomizationStep';
import { ThirdCustomizationStep } from './OnboardingSteps/ThirdCustomizationStep';
import { FourthCustomizationStep } from './OnboardingSteps/FourthCustomizationStep';
import { updateSettings } from '../../../helper/updateSettings';

export function OnboardingPage() {
    const [wizardObj, setWizardObj] = useState(null);
    const [userImageInputObj, setUserImageInputObj] = useState(null);
    const [postImageInputObj, setPostImageInputObj] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [isLaunchStep, setIsLaunchStep] = useState(false);
    const [islastStep, setIsLastStep] = useState(false);
    const [loading, setLoading] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [userImageChanged, setUserImageChanged] = useState(0);
    const [postImageChanged, setPostImageChanged] = useState(0);
    const [otp, setOtp] = useState('');
    const [otpModal, setOtpModal] = useState(false);
    const [otpAuthError, setOtpAuthError] = useState(false);
    const [registrationError, setRegistrationError] = useState('');
    const [defaultPostImage, setDefaultPostImage] = useState('');
    const [handleText, setHandleText] = useState('');
    const [popupMessage, setPopupMessage] = useState('Hi guys, welcome to our stores here you can create your private shopping group');
    const [firstPostText, setFirstPostText] = useState('Hello everyone and welcome to our community, we’re happy to welcome you and can’t wait to chat with you...');
    const [userName, setUserName] = useState('Sam from Squadded');
    const [contentRef, setContentRef] = useState(null);
    const [iframeRef, setIframeRef] = useState(null);
    const [handleDesign, setWidgetShape] = useState('square');
    const [refreshWidget, setRefreshWidget] = useState(0);
    const [prevWizardStep, setPrevWizardStep] = useState(0);
    const [fakePostKey, setFakePostKey] = useState(0);
    const [clickedOnNext, setClickedOnNext] = useState(false);
    const [brandColor, setBrandColor] = useState('#C15EFE');
    const [userToken, setUserToken] = useState('');
    const [changingColor, setChangingColor] = useState(false);
    const [isPopupMessageStep, setIsPopupMessageStep] = useState(false);
    const [postLater, setPostLater] = useState(false);
    const [merchantInfo, setMerchantInfo] = useState({});
    const [guestAvatar, setGuestAvatar] = useState('');
    const [shopifyToken] = useState(new URLSearchParams(window.location.search).get('token'));
    const [shopifyInfo, setShopifyInfo] = useState(null);
    const [showWeWillContactYouMessage, setShowWeWillContactYouMessage] = useState(false);

    const [showWelcomeWizard, setShowWelcomeWizard] = useState(true);
    const [toggleIframeAndWishlistIcon, setToggleIframeAndWishlistIcon] = useState(false);
    const USER_ALREADY_EXISTS = 'userExists';
    const USER_NOT_VALIDATED = 'userNotExists';

    const dispatch = useDispatch();
    const history = useHistory();
    const fakePhoneWithPost = toAbsoluteUrl('/assets/phone-with-merchant.png');
    const fakePhone = toAbsoluteUrl('/assets/X Mockup.png');

    const shouldShowPhoneLayout = !showWelcomeWizard && !showWeWillContactYouMessage;
    useEffect(() => {
        setTimeout(() => {
            setFakePostKey(fakePostKey + 1);
        }, 10);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userImageChanged, postImageChanged]);

    useEffect(() => {
        const init = async () => {
            if (contentRef) {
                setWizardObj(new KTWizard('customization-wizard', {
                    startStep: 1,
                }));
                setPostImageInputObj(new KTImageInput('post-image-upload'));
                setUserImageInputObj(new KTImageInput('user-image-upload'));
                const defaultPicturesOptions = [
                    {
                        squaddedUrl: 'https://static.squadded.co/assets/avatar/avatar' + Math.floor(Math.random() * 50) + '.svg',
                        setFunction: function (e) {
                            return setGuestAvatar(e);
                        },
                    },
                    {
                        squaddedUrl: 'https://squadded-media-staging-us-east-1.s3.amazonaws.com/userdata/00/welcome-to-community.png',
                        setFunction: function (e) {
                            return setDefaultPostImage(e);
                        },
                    },
                ]

                defaultPicturesOptions.forEach(async (picture) => {
                    picture.setFunction(picture.squaddedUrl)
                })
            }
        }
        init();
    }, [contentRef]);

    useEffect(() => {
        const init = async () => {
            if (shopifyToken) {
                const shopifyUserInfo = await getShopifyInfo({ shopifyToken });
                setShopifyInfo(shopifyUserInfo.data);
            }
        }
        init();
    }, [shopifyToken]);

    const prevButtonClicked = () => {
        fireRefreshWidget();
        setIsLaunchStep(false);
        setPrevWizardStep(wizardObj.currentStep);
        setIsPopupMessageStep(wizardObj.currentStep === 2);
        if (!clickedOnNext || prevWizardStep === 1) {
            setShowWelcomeWizard(true);
        }
    };

    const mountNode =
        iframeRef?.contentWindow?.document?.body

    const nextButtonClicked = () => {
        setClickedOnNext(true);
        wizardObj.goNext();
        setPrevWizardStep(wizardObj.currentStep);

        setIsPopupMessageStep(wizardObj.currentStep === 2);
        fireRefreshWidget();
        setIsLaunchStep(wizardObj.currentStep === 3);
        setIsLastStep(wizardObj.currentStep === 4);
    }
    const changePopupMessage = (e) => {
        setPopupMessage(e.target.value);
        fireRefreshWidget();
    }
    const changeWidgetName = (e) => {
        setHandleText(e.target.value);
        fireRefreshWidget();
    }
    const changeWidgetShape = (e) => {
        fireRefreshWidget({ newWidgetShape: e.target.value });
    }
    const changeWidgetColor = (e) => {
        fireRefreshWidget({ newBrandColor: e.target.value });
    }

    useEffect(() => {
        setTimeout(() => {
            if (shouldShowPhoneLayout && !isLaunchStep) {
                setToggleIframeAndWishlistIcon(true)
            } else {
                setToggleIframeAndWishlistIcon(false)
            }
        }, 1000);
    }, [showWelcomeWizard, isLaunchStep, shouldShowPhoneLayout]);

    const fireRefreshWidget = (params = {}) => {
        const { newBrandColor, newWidgetShape } = params;
        if (changingColor) {
            return;
        }
        setChangingColor(true);
        setTimeout(() => {
            setBrandColor(newBrandColor || brandColor);
            setWidgetShape(newWidgetShape || handleDesign);
            setRefreshWidget(refreshWidget + 1);
            setChangingColor(false);
        }, 1000);
    }
    const closeDialog = () => {
        if (registrationError) {
            return history.push('/logout');
        }
        setOpenDialog(false);
        setOtpModal(false);
        setLoading(false);
        setModalLoading(false);

        setOtpAuthError(false);
        setRegistrationError('');
    };

    const loginAdminToOverview = () => {
        if (shopifyInfo) {
            return history.push('/plans');
        } else {
            setShowWeWillContactYouMessage(true)
            setIsLaunchStep(false)
        }
    };

    const showWidgetCustomization = (params) => {
        setMerchantInfo({ ...params });
        const { adminFullname, merchantId } = params;
        const buildUsername = `${adminFullname} from ${merchantId}`
        setUserName(buildUsername);
        setHandleText(params.merchantId.slice(0, 13) + ' Party');
    };

    const createMerchantAndAdmin = async () => {
        setLoading(true);
        const onboardingRegisterResult = await onboardingRegister({
            email: merchantInfo.merchantEmail,
            password: merchantInfo.adminPassword,
            otp,
            merchantId: merchantInfo.merchantId,
            label: merchantInfo.merchantSite,
            url: merchantInfo.merchantSite,
            fullname: merchantInfo.adminFullname,
        });
        const { merchantIsAlreadyExisting, adminIsAlreadyExisting, adminApproved, userToken } = onboardingRegisterResult.data;
        setLoading(false);
        if (merchantIsAlreadyExisting) {
            setModalLoading(false);
            setOtpModal(false);
            setRegistrationError(
                adminIsAlreadyExisting && !adminApproved ? USER_NOT_VALIDATED
                    : USER_ALREADY_EXISTS
            )
            return;
        }
        setUserToken(userToken)
        const snsData = {
            username: merchantInfo.adminFullname,
            website: merchantInfo.merchantSite,
            merchantId: merchantInfo.merchantId,
            email: merchantInfo.merchantEmail,
        }
        sendSnsRegister(snsData);
        if (!adminApproved) {
            closeDialog();
            setShowWelcomeWizard(false);
        } else {
            const optimisticMerchant = {
                merchantId: merchantInfo.merchantId,
                label: merchantInfo.merchantSite,
                url: merchantInfo.merchantSite,
                options: {}
            };
            dispatch(merchantsActions.setMerchants([optimisticMerchant]));
            login(merchantInfo.merchantEmail, merchantInfo.adminPassword).then(data => {
                const loginData = { ...data.data, userFulfilled: true }
                dispatch(
                    actions.login(loginData),
                );
            });
            return true;
        }
    };

    useEffect(() => {
        const submitEmailSendOtp = async () => {
            const merchantEmail = merchantInfo.merchantEmail;

            if (!merchantEmail || !merchantEmail.length) {
                return;
            }
            setLoading(true);
            const res = await sendOtp({
                email: merchantEmail,
                merchantId: merchantInfo.merchantId
            });
            if (res.data.success) {
                setOtpModal(true);
                setOpenDialog(true);
            }
        };
        if (!merchantInfo) {
            return;
        }
        submitEmailSendOtp();
    }, [merchantInfo]);

    const sendAuthOtp = async (e) => {
        e.preventDefault();
        const { merchantEmail, merchantId } = merchantInfo;
        if (!merchantEmail || !merchantId) {
            return;
        }
        try {
            setModalLoading(true);
            const isOk = await createMerchantAndAdmin();
            if (!isOk) {
                return;
            }
            closeDialog();
            setShowWelcomeWizard(false);
            // const resData = JSON.parse(res.data);
            // if (resData.token) {
            //     setUserToken(resData.token);
            // }
        } catch (error) {
            setOtpAuthError(true);
            setLoading(false);
            setModalLoading(false);
        }
    };

    const sendParamsLaunchLater = () => {
        updateSettings({ options: { brandColor, handleText, handleDesign, popupMessage, enable: false } }, merchantInfo.merchantId, shopifyInfo);
        loginAdminToOverview();
    };

    const FinishToSocketAndLogin = async () => {
        setLoading(true);
        updateSettings(
            { options: { brandColor, handleText, handleDesign, popupMessage } },
            merchantInfo.merchantId, shopifyInfo);
        openWebSocket({
            postLater,
            loginAdminToOverview,
            token: userToken,
            merchantId: merchantInfo.merchantId,
            firstPostText,
            userImage: !userImageChanged ? guestAvatar : userImageInputObj.currentImage,
            postImage: !postImageChanged ? defaultPostImage : postImageInputObj.currentImage,
            userImageChanged,
            postImageChanged,
            screenName: userName
        })
    };

    const stepNavs = [
        {
            wizardNumber: 1,
            wizardTitle: 'Customize',
            wizardDesc: 'Brand details',
        },
        {
            wizardNumber: 2,
            wizardTitle: 'Welcome',
            wizardDesc: 'Welcome message',
        },
        {
            wizardNumber: 3,
            wizardTitle: 'Create a post',
            wizardDesc: 'First post',
        },
    ]

    const wizardSteps = [
        <FirstCustomizationStep classNames={classNames} changeWidgetName={changeWidgetName} handleText={handleText} changeWidgetColor={changeWidgetColor} brandColor={brandColor} changeWidgetShape={changeWidgetShape} />,
        <SecondCustomizationStep classNames={classNames} changePopupMessage={changePopupMessage} popupMessage={popupMessage} />,
        <ThirdCustomizationStep classNames={classNames} postLater={postLater} setUserName={setUserName} userName={userName} toAbsoluteUrl={toAbsoluteUrl} guestAvatar={guestAvatar} setUserImageChanged={setUserImageChanged} userImageChanged={userImageChanged} firstPostText={firstPostText} setFirstPostText={setFirstPostText} fakePostDefaultPicture={fakePostDefaultPicture} setPostImageChanged={setPostImageChanged} postImageChanged={postImageChanged} setPostLater={setPostLater} />,
        <FourthCustomizationStep classNames={classNames} getStartedPdf={getStartedPdf} />,
    ];
    return (
        <div
            className={classNames(s.inputBackgroundColor, 'content d-flex flex-row flex-row-fluid')} id="kt_content"
            style={{ padding: '0', backgroundColor: 'white', fontFamily: 'Roboto', paddingLeft: '15vw' }}>
            <Logo
                className={classNames(s.logo)}
                height="25" />
            <Dialog
                open={openDialog}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        closeDialog()
                    }
                }}
                maxWidth='xs'
            >
                {otpModal
                    ?
                    <>
                        <DialogTitle style={{ textAlign: 'center', marginTop: '20px' }}>
                            <div className={classNames([s.stepHeader, s.fontWeight600, s.blackFont])}>User Verification
                            </div>
                            <div style={{
                                letterSpacing: '0.1px',
                                fontSize: '1.53rem',
                                fontWeight: '400'
                            }}>

                                Please enter the code we sent to {merchantInfo.merchantEmail}
                            </div>
                        </DialogTitle>
                        <DialogContent style={{ textAlign: 'center', marginBottom: '30px' }}>
                            <form onSubmit={sendAuthOtp}>
                                <div className="form-group">
                                    <input maxLength="4" onChange={(e) => setOtp(e.target.value)} type="text" className="form-control form-control-solid h-auto p-5 border-0 rounded-lg font-size-h6" name="otp" placeholder="1234" defaultValue="" />
                                </div>
                                <button onClick={closeDialog} data-wizard-type="reset" type="reset" className="btn btn-secondary font-weight-bolder font-size-h6 px-8 pr-4 py-4 my-3">
                                    Cancel
                                </button>
                                <button onClick={sendAuthOtp} disabled={otp.length !== 4} data-wizard-type="action-submit" type="submit" className="btn btn-dark font-weight-bolder font-size-h6 px-8 pr-4 py-4 m-3">
                                    {modalLoading ?
                                        <>
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </>
                                        :
                                        <>
                                            Submit
                                        </>
                                    }
                                </button>
                            </form>
                            {otpAuthError ?
                                <span>
                                    Looks like the code you entered is invalid. Please try again.
                                </span>
                                :
                                <span>
                                    Allow up to 1 minute to receive it. Remember to check your spam/junk folder.
                                </span>
                            }
                        </DialogContent>
                    </>
                    :
                    <>
                        <DialogTitle style={{ textAlign: 'center', marginTop: '20px' }}>
                            {registrationError === USER_ALREADY_EXISTS ?
                                <span>Your Squadded account already exists, please login.
                                </span>
                                : registrationError === USER_NOT_VALIDATED ?
                                    <>
                                        <div>your account is under validation.
                                        </div>
                                        <div>Please send an email to contact@squadded.co
                                        </div>
                                    </>
                                    :
                                    <span> Looks like there are some errors detected, please try again.
                                    </span>
                            }

                        </DialogTitle>
                        <DialogContent style={{ textAlign: 'center', marginBottom: '30px' }}>
                            {registrationError === USER_NOT_VALIDATED ?
                                <button
                                    className='btn btn-secondary'
                                    href='mailto:contact@squadded.com'
                                    onClick={() => window.open('mailto:contact@squadded.com')}
                                >
                                    Contact Us
                                </button> :
                                <span onClick={closeDialog} className="btn btn-secondary">Ok, got it!</span>
                            }
                        </DialogContent>
                    </>
                }
            </Dialog>
            {
                showWelcomeWizard
                    ?
                    <>
                        <FirstStepsCustomization
                            setMerchantInfo={showWidgetCustomization}
                            merchantInfo={merchantInfo}
                            loading={loading}
                            shopifyUserInfo={shopifyInfo}
                        />
                        <div className='position-absolute text-right flex-column-auto justify-content-center' style={{ top: '2vw', right: '679.625px' }}>
                            <span className='font-weight-bold text-dark-50'>Already have an account?</span>
                            <Link to='/' className='font-weight-bold ml-2' id='kt_login_signup'>
                                Sign In!
                            </Link>
                        </div>
                    </>
                    :
                    showWeWillContactYouMessage
                        ?
                        <div className={s.showWeWillContactYouMessage}>
                            <FourthCustomizationStep classNames={classNames} getStartedPdf={getStartedPdf} />
                        </div>
                        :
                        <div className="d-flex flex-column-fluid">
                            <div ref={setContentRef} style={{ paddingTop: '111px' }} className="wizard wizard-6 d-flex flex-column flex-lg-row flex-column-fluid" id="customization-wizard">
                                <div className="wizard-content d-flex flex-column w-100 w-md-700px"
                                    style={{ marginRight: 'auto' }}>
                                    <div className="d-flex flex-column-auto flex-column">
                                        <div className="wizard-nav pb-lg-14 pb-3 d-flex flex-column align-items-center align-items-md-start">
                                            <div className="wizard-steps d-flex flex-column flex-md-row">
                                                {!islastStep && stepNavs.map(step =>
                                                    <div key={step.wizardNumber} className="wizard-step flex-grow-1 flex-basis-0" data-wizard-type="step">
                                                        <div className="wizard-wrapper pr-lg-7 pr-5">
                                                            {step.wizardNumber !== 1 ?
                                                                <i><ArrowForwardOutlinedIcon className='mx-6' /></i> : null
                                                            }
                                                            <div className="wizard-icon" style={{ height: '48px', width: '48px', marginRight: '8px', }}>
                                                                <i className="wizard-check"><CheckIcon /></i>
                                                                <span className="wizard-number">{step.wizardNumber}</span>
                                                            </div>
                                                            <div className="wizard-label mr-3" style={{ flexDirection: 'row' }}>
                                                                <div style={{ width: 'max-content' }}>
                                                                    <div className="wizard-title" style={{ fontSize: '1.23rem' }}>{step.wizardTitle}</div>
                                                                    <div className="wizard-desc" style={{ fontSize: '0.923rem', fontWeight: 500 }}>{step.wizardDesc}</div>
                                                                </div>
                                                            </div>
                                                            <span className="svg-icon">
                                                            </span>
                                                        </div>
                                                    </div>
                                                )}
                                                <div data-wizard-type="step" className="step-done-empty">
                                                    <div className="wizard-wrapper pr-lg-7 pr-5">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <form id="kt_form" style={{
                                        display: 'flex',
                                        flexFlow: 'column',
                                        justifyContent: 'space-between', height: '100%'
                                    }}>
                                        {wizardSteps.map((step, index) =>
                                            <div key={index} data-wizard-type="step-content">
                                                {step}
                                            </div>
                                        )}
                                        {!islastStep &&
                                            <div className="d-flex" style={{ marginBottom: '4.077rem' }}>
                                                <div style={{ marginRight: '27rem' }}>
                                                    <button style={{ fontSize: '1.23rem', fontWeight: 500, backgroundColor: '#DEDFE0' }} onClick={() => prevButtonClicked(wizardObj)} type="button" className="btn pr-8 pl-6 py-4  mr-3" data-wizard-type="action-prev">
                                                        <span className="svg-icon svg-icon-md mr-2">

                                                        </span> <i style={{ color: 'black' }}><ArrowBackOutlinedIcon
                                                        /></i>Previous</button>
                                                </div>
                                                <div>
                                                    {isLaunchStep
                                                        ?
                                                        <button
                                                            disabled={!userName}
                                                            data-wizard-type="action-submit"
                                                            type="button"
                                                            onClick={FinishToSocketAndLogin}
                                                            className="btn btn-dark font-weight-bolder font-size-h6 pl-8 pr-4 py-4">
                                                            Launch Squadded
                                                            {loading ?
                                                                <>
                                                                    <span style={{ marginLeft: '1.3rem' }} className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                                </>
                                                                :
                                                                <>
                                                                    <i><ArrowForwardOutlinedIcon style={{ marginLeft: '0.4rem' }} /></i>
                                                                </>
                                                            }
                                                        </button>
                                                        :
                                                        <button type="button" onClick={nextButtonClicked} className="btn btn-dark font-weight-bold font-size-h6 pl-8 pr-4 py-4">
                                                            Next
                                                            <i><ArrowForwardOutlinedIcon style={{ marginLeft: '0.4rem' }} /></i>
                                                            <span className="svg-icon svg-icon-md ml-2">
                                                            </span></button>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </form>
                                    {isLaunchStep && !islastStep ?
                                        <div className={classNames([s.mediumTextSize, s.fontWeight500, s.launchLater])}>
                                            <LightBulb style={{ marginRight: '1rem' }} />
                                            <span className={classNames(s.launchLaterMain)}>
                                                Not ready to launch? Explore Squadded and&nbsp;
                                            </span>
                                            <span onClick={sendParamsLaunchLater} className={classNames(s.launchLaterLink)}>launch later</span>
                                        </div>
                                        : null
                                    }
                                </div>
                            </div>
                        </div >
            }
            <div className={classNames(s.gradient)}>
                <div
                    className={`${shouldShowPhoneLayout ? s.phoneImageContainer : s.peopleImageContainer}`}>
                    <img src={toAbsoluteUrl('/assets/onboarding-people.png')} alt=""
                        style={{
                            // maxWidth: '80%',
                            opacity: shouldShowPhoneLayout ? '0' : '1',
                            transition: 'all 0.5s ease 0s',
                            display: 'block',
                            height: shouldShowPhoneLayout ? '430px' : '',
                            width: '100%',
                        }}
                    >
                    </img>
                    {isLaunchStep ?
                        <div className={classNames(s.fakePostContainer)}>
                            <FakePost
                                key={fakePostKey}
                                postText={firstPostText}
                                userName={userName}
                                userImageInputObj={userImageInputObj}
                                postImageInputObj={postImageInputObj}
                            />
                        </div> : null
                    }
                    {shouldShowPhoneLayout &&
                        <img src={isLaunchStep ? fakePhoneWithPost : fakePhone} alt=""
                            className={classNames(s.phoneImg)}
                            style={{ marginTop: shouldShowPhoneLayout ? '-395px' : '263px' }}
                        >
                        </img>
                    }
                    {!toggleIframeAndWishlistIcon ?
                        null
                        :
                        <div>
                            <div className={classNames(s.wishlistIcon)}>
                                <WishlistIcon fill={brandColor} />
                            </div>
                            <iframe title="frame" ref={setIframeRef} key={refreshWidget} style={{
                                right: handleDesign ? '27px' : '94px',
                                top: (handleDesign === 'square') ? '366px' : '450px',
                                height: '280px',
                            }}>
                                {mountNode && createPortal(<WidgetOnly
                                    merchantId={merchantInfo.merchantId}
                                    handleDesign={handleDesign}
                                    handleText={handleText}
                                    brandColor={brandColor}
                                    popupMessage={popupMessage}
                                    isPopupMessageStep={isPopupMessageStep}
                                />, mountNode)}
                            </iframe>
                        </div>
                    }

                </div>
            </div>
        </div >
    )
}
